<template>
  <!-- The animated Vysual mark. Under reduced motion it falls back to the static
       mark rather than swapping one animation for another. -->
  <img
    :src="reduceMotion ? STATIC_MARK : ANIMATED_MARK"
    :width="pixels"
    :height="pixels"
    :style="{ width: `${pixels}px`, height: `${pixels}px` }"
    class="brand-loader"
    alt=""
    aria-hidden="true"
  />
</template>

<script setup>
import { computed, ref } from 'vue';

const ANIMATED_MARK = '/assets/img/vysual-loader.webp';
const STATIC_MARK = '/assets/img/vysual-brand-mark.svg';

// FontAwesome size tokens, so the call sites this replaced keep their sizing
// vocabulary instead of every one needing a pixel value.
const FA_SIZE_PX = {
  xs: 24,
  sm: 32,
  '1x': 40,
  lg: 48,
  '2x': 96,
  '3x': 128,
  '4x': 160,
  '5x': 200,
};

const props = defineProps({
  // A FontAwesome token ('2x', 'lg', …) or a number of pixels.
  size: {
    type: [String, Number],
    default: '2x',
  },
});

const reduceMotion = ref(
  typeof window !== 'undefined' &&
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches,
);

const pixels = computed(() => {
  if (typeof props.size === 'number') return props.size;
  return FA_SIZE_PX[props.size] || FA_SIZE_PX['2x'];
});
</script>

<style scoped>
.brand-loader {
  display: inline-block;
  object-fit: contain;
  /* The source has its own padding, so it optically reads smaller than its box. */
  max-width: 100%;
}
</style>
